import {
  Component,
  DestroyRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';
import { DcPopoverComponent } from '../dc-popover/dc-popover.component';

@Component({
  selector: 'app-dc-toggle',
  templateUrl: './dc-toggle.component.html',
  styleUrls: ['./dc-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DcToggleComponent,
      multi: true,
    },
  ],
})
export class DcToggleComponent extends ControlValueAccessorConnector {
  @Input() disabled: boolean;
  @Input() id: string;
  @Input() labelId: string;
  @Input() label: string;
  @Input() helpText: string;
  @Input() showRequiredLabel: boolean = false;

  @Output() changed = new EventEmitter<boolean>();

  @Input() size: 'small' | null = null;
  @Input() reverse: boolean;

  @ViewChild(DcPopoverComponent)
  popover: DcPopoverComponent;

  private destroyRef = inject(DestroyRef);

  private _value = false;

  ngOnInit(): void {
    if (isNullOrUndefined(this.control.value)) {
      this.control.setValue(false, { emitEvent: false });
    }

    this.control.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        if (this.control['readOnly']) {
          return;
        }

        if (this.control.touched) {
          this.changed.emit(value);
        }

        setTimeout(() => this.popover?.click());
      });
  }

  toggleValue(): void {
    if (this.readonly) {
      return;
    }

    this.onTouchFn?.();
    this.writeValue(!this.value);
  }

  writeValue(obj: any): void {
    this._value = obj;
    this.onChangeFn?.(obj);
  }

  get value(): boolean {
    return this._value;
  }

  @HostBinding('class.small')
  get isSmall(): boolean {
    return this.size === 'small';
  }

  @HostBinding('class.reverse')
  get isReverse(): boolean {
    return this.reverse;
  }

  canShowRequiredLabel(): boolean {
    return this.showRequiredLabel && this.control.hasValidator(Validators.required);
  }
}
